import {
  VG_START_SIGNALR_CONN,
  VG_STARTED_SIGNALR_CONN,
  VG_STOP_SIGNALR_CONN,
  VG_STOPPED_SIGNALR_CONN,
  VG_RECONNECTING_SIGNALR_CONN,
  VG_RECONNECTED_SIGNALR_CONN,
  VG_FAILED_SIGNALR_CONN,
  VG_SET_MESSAGE,
  VG_REMOVE_MESSAGE,
  VG_REMOVE_ALL_MESSAGES,
  LOGOUT_EVENT,
} from "./actionTypes";

const initialState = {
  connSignalR: null,
  chats: {},
  logoutEvent: false,
};

const SignalR = (state = initialState, action) => {
  switch (action.type) {
    case VG_START_SIGNALR_CONN:
      state = {
        ...state,
        connSignalR: {
          error: false,
          loading: true,
          success: false,
          connection: "connecting",
          className: "spinner-border text-secondary m-1",
          type: VG_START_SIGNALR_CONN,
        },
      };
      break;
    case VG_STARTED_SIGNALR_CONN:
      state = {
        ...state,
        connSignalR: {
          data: action.payload.data,
          error: false,
          loading: false,
          success: true,
          connection: "online",
          className: "bg-success m-1",
          status: action.payload.status,
          type: VG_STARTED_SIGNALR_CONN,
        },
      };
      break;
    case VG_STOP_SIGNALR_CONN:
      state = {
        ...state,
        connSignalR: {
          error: false,
          loading: true,
          success: false,
          connection: "disconnecting",
          className: "spinner-border text-danger m-1",
          type: VG_STOP_SIGNALR_CONN,
        },
      };
      break;
    case VG_STOPPED_SIGNALR_CONN:
      state = {
        ...state,
        connSignalR: {
          error: false,
          loading: true,
          success: false,
          connection: "disconnected",
          className: "spinner-border text-secondary m-1",
          type: VG_STOPPED_SIGNALR_CONN,
        },
      };
      break;

    case VG_RECONNECTING_SIGNALR_CONN:
      state = {
        ...state,
        connSignalR: {
          data: state.connSignalR.data,
          error: true,
          loading: true,
          success: false,
          connection: "reconnecting",
          className: "spinner-border text-danger m-1",
          type: VG_RECONNECTING_SIGNALR_CONN,
        },
      };
      break;
    case VG_RECONNECTED_SIGNALR_CONN:
      state = {
        ...state,
        connSignalR: {
          data: state.connSignalR.data,
          error: false,
          loading: false,
          success: true,
          connection: "reconnected",
          className: "bg-success m-1",
          status: action.payload.status,
          type: VG_RECONNECTED_SIGNALR_CONN,
        },
      };
      break;

    case VG_FAILED_SIGNALR_CONN:
      state = {
        ...state,
        connSignalR: {
          data: action.payload.data,
          error: true,
          loading: false,
          success: false,
          connection: "failed",
          className: "bg-danger m-1",
          status: action.payload.status,
          type: VG_FAILED_SIGNALR_CONN,
        },
      };
      break;

    case VG_SET_MESSAGE:
      let id = action?.payload?.data?.conversationId;
      let messages = [
        ...(state?.chats[id] || ""),
        ...action?.payload?.data?.message,
      ];

      state = {
        ...state,
        chats: {
          ...state?.chats,
          [id]: messages,
        },
      };
      break;
    case VG_REMOVE_MESSAGE:
      const { [action?.payload]: removed, ...newChat } = state?.chats;
      state = {
        ...state,
        chats: newChat,
      };
      break;
    case VG_REMOVE_ALL_MESSAGES:
      state = {
        ...state,
        chats: {},
      };
      break;
    case LOGOUT_EVENT: {
      state = {
        ...state,
        logoutEvent: action.payload.open,
      };
      break;
    }

    default:
      // do nothing
      break;
  }
  return state;
};

export default SignalR;
